/* biome-ignore lint/correctness/noUnusedImports: React is required for JSX runtime */
import React from "react";

import Input from "../../app2components/base/Input";
import { INPUT_TYPE_NUMBER } from "../../constants/ElementConstants";
import { OPACITY, BLUR } from "@/constants/MergeConstants";
import { getInputDefaults, mapHandlers } from "./BaseInputConfigMap";

const OPACITY_DEFAULTS = getInputDefaults(OPACITY);
const BLUR_DEFAULTS = getInputDefaults(BLUR);

export const OpacityInput = ({ context, disabled, value, onBeforeChange, onInput }) => (
  <Input
    {...OPACITY_DEFAULTS}
    {...mapHandlers({ onBeforeChange, onInput })}
    data-testid="opacity-input"
    context={context}
    disabled={disabled}
    type={INPUT_TYPE_NUMBER}
    value={value}
  />
);

export const BlurInput = ({ context, disabled, value, onBeforeChange, onInput }) => (
  <Input
    {...BLUR_DEFAULTS}
    {...mapHandlers({ onBeforeChange, onInput })}
    context={context}
    data-testid="blur-input"
    disabled={disabled}
    type={INPUT_TYPE_NUMBER}
    value={value ?? 0}
  />
);
